import MarkdownIt from 'markdown-it';

/**
 * Renders markdown to HTML.
 *
 * @param md
 */
export function markdownToHtml(md) {
  var markdownInstance = new MarkdownIt({
    linkify: true,
    breaks: true
  });
  var html = markdownInstance.render(md);
  return html.replace(/<a href=/gi, '<a target="_blank" href=');
}
//# sourceMappingURL=markdownUtil.js.map
